import router from "./router";
import store from "./store";
import { createApp } from "vue";
import App from "./App.vue";
import "./index.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

// import { GoogleLogin } from 'vue3-google-login'

const app = createApp(App);
library.add(faUserSecret, fas, fab, far);
app.component("font-awesome-icon", FontAwesomeIcon);

app.use(router);
app.use(store);
store.dispatch('bowsys/fetchUser');


// app.use(GoogleLogin, {
//     clientId: '289671570944-hs1or1s6k8b32r6v3ge8gn58jdt1jb3r.apps.googleusercontent.com'
//   })

app.mount("#app");
